import React, { useEffect, useState, useMemo } from 'react';
import { collection, getDocs, updateDoc, doc, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import './ApproveUsers.css'; // Import the CSS file

const ApproveUsers = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [approvingId, setApprovingId] = useState(null); // Track which user is being approved

  // Fetch only pending users
  const fetchPendingUsers = async () => {
    setLoading(true);
    setError('');
    try {
      // Query for users where approved is false
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('approved', '==', false));
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      setPendingUsers(data);
    } catch (err) {
      console.error("Error fetching pending users:", err);
      setError('Gagal memuat data pengguna yang menunggu persetujuan.');
    } finally {
      setLoading(false);
    }
  };

  // Handle approval
  const handleApprove = async (id) => {
    setApprovingId(id); // Set loading state for this specific button
    setError('');
    try {
      await updateDoc(doc(db, 'users', id), { approved: true });
      // Remove the user from the pending list locally
      setPendingUsers(currentUsers => currentUsers.filter(u => u.id !== id));
      console.log(`User ${id} approved.`);
    } catch (err) {
      console.error("Error approving user:", err);
      setError(`Gagal menyetujui pengguna ${id}.`);
    } finally {
      setApprovingId(null); // Reset loading state for this button
    }
  };

  useEffect(() => {
    fetchPendingUsers();
  }, []);

  return (
    <div className="approve-users-container">
      <h2>Persetujuan Pengguna Baru</h2>

      {error && <div className="error-message">{error}</div>}

      {loading && !pendingUsers.length ? ( // Show loading only on initial load
        <div className="loading-message">Memuat data...</div>
      ) : (
        <div className="approve-users-table-container">
          <table className="approve-users-table">
            <thead>
              <tr>
                <th>Nama</th>
                <th>Email</th>
                <th>Role Diminta</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {pendingUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.nama || 'N/A'}</td>
                  <td>{user.email || 'N/A'}</td>
                  <td>{user.role || 'N/A'}</td>
                  <td className="action-buttons">
                    <button
                      onClick={() => handleApprove(user.id)}
                      className="btn btn-approve"
                      disabled={approvingId === user.id} // Disable only the button being clicked
                    >
                      {approvingId === user.id ? 'Menyetujui...' : 'Setujui'}
                    </button>
                  </td>
                </tr>
              ))}
              {pendingUsers.length === 0 && !loading && (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>Tidak ada pengguna yang menunggu persetujuan.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ApproveUsers;
